import {
  useEffect,
  useState
} from "react";

import {
  Link
} from "react-router-dom";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getSalesOrders
}
from "../../api/salesOrderApi";

const SalesOrderList = () => {

  const [orders,setOrders] =
  useState([]);

  useEffect(()=>{

    loadOrders();

  },[]);

  const loadOrders =
  async()=>{

    try{

      const res =
      await getSalesOrders();

      setOrders(
        res.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }

  };

  return(

    <MainLayout>

      <div className="card shadow-sm">

        <div className="card-header">

          <h5>
            Sales Orders
          </h5>

        </div>

        <div className="card-body">

          <table className="table table-hover">

            <thead>

              <tr>

                <th>SO No</th>
                <th>Customer</th>
                <th>Order Date</th>
                <th>Status</th>
                <th>Action</th>

              </tr>

            </thead>

            <tbody>

              {
                orders.map(
                  order=>(

                    <tr
                      key={order.id}
                    >

                      <td>

                        {
                          order.so_no
                        }

                      </td>

                      <td>

                        {
                          order.customer_name
                        }

                      </td>

                      <td>

                        {
                          order.order_date
                        }

                      </td>

                      <td>

                        <span
                          className="badge bg-primary"
                        >

                          {
                            order.status
                          }

                        </span>

                      </td>

                      <td>

                        <Link
                          to={`/dispatch-from-so/${order.id}`}
                          className="btn btn-success btn-sm"
                        >

                          Dispatch

                        </Link>

                      </td>

                    </tr>

                  )
                )
              }

            </tbody>

          </table>

        </div>

      </div>

    </MainLayout>

  );

};

export default SalesOrderList;